import React from 'react'
import TimeField from '../../formFields/timeField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <TimeField {...fieldProps} />
))
